import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import ResponsiveImage from 'components/Common/ResponsiveImage'

const RoomGalleryButton = styled(Clickable)`
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  cursor: pointer;
`

interface Props {
  id: string
  width: number
  height: number
  mobileWidth: string
  onOpenRoomGallery?: () => void
  openRoomGalleryLabel?: string
}

function SuggestedOptionPreviewRoomImage({
  id,
  width,
  height,
  mobileWidth,
  onOpenRoomGallery,
  openRoomGalleryLabel,
}: Props) {
  const image = <ResponsiveImage
    id={id}
    width={width}
    height={height}
    mobileWidth={mobileWidth}
    aspectRatio="1"
    fit="center"
    quality="good"
    dpr={2}
  />

  if (!onOpenRoomGallery) {
    return image
  }

  return <RoomGalleryButton onClick={onOpenRoomGallery} aria-label={openRoomGalleryLabel}>
    {image}
  </RoomGalleryButton>
}

export default SuggestedOptionPreviewRoomImage
